import { forwardRef, useCallback } from 'react';
import { AutoComplete, type AutoCompleteProps, type RefSelectProps } from 'antd';
import type { DefaultOptionType } from 'antd/es/select';
import { sanitizeInput } from '@/lib/utils';

export const SanitizedAutoComplete = forwardRef<RefSelectProps, AutoCompleteProps>(
  ({ onChange, onSearch, ...props }, ref) => {
    const handleChange = useCallback(
      (value: string, option?: DefaultOptionType | DefaultOptionType[]) => {
        onChange?.(sanitizeInput(value), option);
      },
      [onChange],
    );

    const handleSearch = useCallback(
      (value: string) => {
        onSearch?.(sanitizeInput(value));
      },
      [onSearch],
    );

    return <AutoComplete ref={ref} {...props} onChange={handleChange} onSearch={handleSearch} />;
  },
);

SanitizedAutoComplete.displayName = 'SanitizedAutoComplete';
